const url='http://117.78.21.84:8080';
// const url='http://localhost:8080';
const axios = require('axios');

// 获取跑马灯文章列表
export  function marList(){
     return axios.get(url+'/cms/common/marList')
}
// 获取跑马灯文章详细信息
export  function getMarInfo(id){
     return axios.get(url+'/cms/common/getMar/'+id)
}
// 获取通知公告最新五条
export  function getFiveNotice(id){
     return axios.get(url+'/cms/common/moduleNewsTop5/'+id)
}
//获取所有通知公告
export  function getAllNotice(data){
     return axios.get(url+'/cms/common/dailyAllList',{
          params:data
     })
}
// 获取监管动态最新五条
export  function superviseList(){
     return axios.get(url+'/cms/common/superviseList')
}
// 获取协会动态最新五条
export  function associationList(){
     return axios.get(url+'/cms/common/associationList')
}
// 获取会员园地最新五条
export  function meberList(){
     return axios.get(url+'/cms/common/meberList')
}
// 获取投资者教育最新五条
export  function educationList(){
     return axios.get(url+'/cms/common/educationList')
}
// 获取一条通知公告详细信息
export  function getDaily(id){
     return axios.get(url+'/cms/common/getDaily/'+id)
}
//获取模块信息
export  function moduleName(id){
     return axios.get(url+'/cms/common/moduleName/'+id)
}
// 获取一条信息
export  function getMessage(id){
     return axios.get(url+'/cms/common/getMessage/'+id)
}
// 根据模块获取信息list
export  function getMessageList(id,data){
     return axios.get(url+'/cms/common/getMessageList/'+id,{params:data})
}
// 从业人员公示查询
export  function getPractitioner(data){
     return axios.get(url+'/cms/common/getPractitioner',{params:data})
}
// 获取网站的访问次数
export  function visitNumber(){
     return axios.get(url+'/cms/common/visitNumber')
}
// 按区域和机构类型（期货证券）查询会员单位
export  function getMember(data){
     return axios.get(url+'/cms/common/getMember',{params:data})
}
// 查看从业人员信息
export  function getInfoPractitioner(id){
     return axios.get(url+'/cms/common/getInfoPractitioner/'+id)
}
// 5条新闻图片数据
export  function imageNewsRecent(){
     return axios.get(url+'/cms/common/imageNewsRecent5')
}
// 新闻图片数据
export  function imageNews(){
     return axios.get(url+'/cms/common/imageNews')
}
// 模糊查询获取文章内容
export  function getSearchResult(value){
     return axios.get(url+'/cms/common/articalList',{params:value})
}
// 获取6条期刊
export  function getSixJournal(){
     return axios.get(url+'/cms/common/getJournalFiveList')
}
// 获取所有期刊
export  function getJournalList(data){
     return axios.get(url+'/cms/common/getJournalListAll',{params:data})
}
